/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileArrowsUpRight: {
  name: 'file-arrows-up-right';
  data: string;
} = {
  name: 'file-arrows-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 1 2-2h6.586a2 2 0 0 1 .242.015 1.006 1.006 0 0 1 .99.41c.064.05.124.103.182.16L19.414 8c.058.058.112.118.161.182a.999.999 0 0 1 .41.99c.01.08.015.16.015.242V20a2 2 0 0 1-2 2h-4a1 1 0 1 1 0-2h4V10h-4a2 2 0 0 1-2-2V4H6v8a1 1 0 1 1-2 0V4Zm10 4V5.414L16.586 8H14ZM4 16a1 1 0 0 0 1 1h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414L9 18.414V21a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z" fill="currentColor"/></svg>`,
};
